import { __assign } from 'tslib';
import React__default from 'react';
import { Box, Button, Link } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useSpring, animated } from 'react-spring';
import { useRecoilValue } from 'recoil';
import DefaultIcon from '../../DefaultIcon/index.js';
import KModalContentSection from '../../KModal/KModalContentSection/index.js';
import { indexationProgressionAtom } from '../../providers/indexation/atoms.js';
import { useUpload } from '../../providers/upload/hooks/useUpload.js';
import SanitizeHtml from '../../SanitizeHtml/index.js';
import ImportForm from './ImportForm.js';
import StyledImportIndexing, { classes } from './index.styled.js';

var ImportIndexing = function (_a) {
    var _b;
    var _c = _a.testId, testId = _c === void 0 ? "ImportUpload" : _c, id = _a.id, className = _a.className, sx = _a.sx, fields = _a.fields, elements = _a.elements, loading = _a.loading, uploadKey = _a.uploadKey, onCancel = _a.onCancel, onSendAssets = _a.onSendAssets, _d = _a.KIcon, KIcon = _d === void 0 ? DefaultIcon : _d;
    var t = useTranslation("refront-components").t;
    var openUploadDialog = useUpload(uploadKey).openUploadDialog;
    var indexationProgressionValue = useRecoilValue(indexationProgressionAtom);
    var indexationProgression = useSpring({
        val: indexationProgressionValue,
        from: { val: 0 }
    });
    var pluralizeTranslationKey = function (key) {
        return elements.length > 1 ? "".concat(key, "_plural") : key;
    };
    return (React__default.createElement(StyledImportIndexing, { id: id, "data-testid": testId, className: clsx("ImportIndexing", className), sx: __assign({ display: "flex", justifyContent: "left", paddingLeft: function (theme) { return theme.spacing(2); }, height: "100%" }, sx) },
        React__default.createElement(KModalContentSection, { className: classes.contentSection, sx: {
                width: "26rem",
                height: "70vh",
                alignSelf: "end",
                paddingRight: function (theme) { return theme.spacing(1); },
                overflowY: "auto",
                "::-webkit-scrollbar": {
                    /* Chrome & IE & Edge */
                    width: "7px",
                    background: function (theme) { return theme.palette.grey[100]; }
                },
                "::-webkit-scrollbar-thumb": {
                    background: function (theme) { return theme.palette.grey[400]; }
                },
                scrollbarWidth: "thin" /* Firefox */
            }, title: React__default.createElement(Box, { sx: {
                    fontSize: "2.5rem",
                    lineHeight: "1",
                    marginBottom: function (theme) { return theme.spacing(2); },
                    color: function (theme) { return theme.palette.common.white; }
                } },
                React__default.createElement(SanitizeHtml, { html: t(pluralizeTranslationKey("components.importIndexing.title")) })), description: React__default.createElement(Box, { sx: {
                    color: function (theme) { return theme.palette.common.white; }
                } },
                React__default.createElement(SanitizeHtml, { html: t(pluralizeTranslationKey("components.importIndexing.content.description")) }),
                React__default.createElement(ImportForm, { fields: fields, KIcon: KIcon }),
                React__default.createElement(Button, { "data-testid": "ValidateImportButton", color: "primary", variant: "contained", disabled: loading && indexationProgressionValue === undefined, sx: {
                        margin: function (theme) { return theme.spacing(2, 0); },
                        padding: function (theme) { return theme.spacing(1, 4); },
                        width: "100%",
                        backgroundColor: loading ? "#1976d2 !important" : "",
                        ".MuiLoadingButton-loadingIndicator": {
                            color: "white !important"
                        }
                    }, onClick: onSendAssets },
                    indexationProgressionValue === undefined && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(KIcon, { sx: { marginRight: function (theme) { return theme.spacing(1); }, fontSize: "18px !important" }, className: "fa-regular fa-arrow-right" }),
                        React__default.createElement(SanitizeHtml, { html: t(pluralizeTranslationKey("components.importIndexing.content.actions.sendAssets.label")) }))),
                    loading && indexationProgressionValue !== undefined && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(animated.div, { className: "number" }, (_b = indexationProgression === null || indexationProgression === void 0 ? void 0 : indexationProgression.val) === null || _b === void 0 ? void 0 : _b.interpolate(function (val) { return Math.floor(val); })),
                        "%"))),
                React__default.createElement(Box, { sx: { div: { display: "inline", marginRight: function (theme) { return theme.spacing(0.5); } } } },
                    React__default.createElement(Link, { component: "button", color: "inherit", variant: "body1", sx: { verticalAlign: "unset" }, onClick: openUploadDialog },
                        React__default.createElement(SanitizeHtml, { html: t("components.importIndexing.content.actions.selectAssets.label") })),
                    React__default.createElement(SanitizeHtml, { html: t("components.importIndexing.content.or") }),
                    React__default.createElement(Link, { component: "button", color: "inherit", variant: "body1", sx: { verticalAlign: "unset" }, onClick: onCancel },
                        React__default.createElement(SanitizeHtml, { html: t("components.importIndexing.content.actions.cancel.label") })))) })));
};

export { ImportIndexing as default };
//# sourceMappingURL=index.js.map
